export const getEventNameForURL = (eventName) =>
	eventName.toLowerCase().replace(/ /g, "-");
